<div class="container-fluid">
    <div class="card">
        <ul ngbNav #nav="ngbNav" [activeId]="1" class="nav-tabs nav-tabs-custom g-nav-tabs-custom"
            style="padding-top: 7px;">
            <li [ngbNavItem]="1">
                <a ngbNavLink>On Call Booking</a>
                <ng-template ngbNavContent>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="p-3"></div>
        <div class="card-body">
            <form class="row" *ngIf="isOnCallActionAllowed" [formGroup]="filterForm">
                <!-- <div class="col-2">
                    <label class="font-size-font">Location<sup class="mandatory">*</sup></label>
                    <ng-multiselect-dropdown class="routing-oncall-multi" formControlName="locations"
                        [placeholder]="'Choose Locations'" [settings]="cardLocationSettings" [data]="locationList"
                        (onSelect)="onItemSelectloc()" (onDeSelect)="OnItemDeSelectloc()"
                        (onSelectAll)="onSelectAllloc()" (onDeSelectAll)="onDeSelectAllloc()">
                    </ng-multiselect-dropdown>
                </div>
                <div class="col-2">
                    <label class="font-size-font">Site<sup class="mandatory">*</sup></label>
                    <ng-multiselect-dropdown class="routing-oncall-multi" formControlName="sites"
                        [placeholder]="'Choose Sites'" [settings]="cardSiteSettings" [data]="_mCardSitesData">
                    </ng-multiselect-dropdown>
                </div> -->
                <div class="col-2">
                    <label>From date <sup class="mandatory">*</sup></label>
                    <mat-form-field appearance="outline" class="on-call-date">
                        <input matInput [matDatepicker]="fromPicker" (click)="fromPicker.open()"
                            (dateChange)="onFromDateChanged()" readonly placeholder="From date" [(ngModel)]="fromDate"
                            [ngModelOptions]="{standalone: true}">
                        <mat-datepicker-toggle matSuffix [for]="fromPicker">
                            <img matDatepickerToggleIcon src="assets/images/bx-calendar.svg">
                        </mat-datepicker-toggle>
                        <mat-datepicker #fromPicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-2">
                    <label>To date <sup class="mandatory">*</sup></label>
                    <mat-form-field appearance="outline" class="on-call-date">
                        <input matInput [min]="fromDate" [matDatepicker]="toPicker" (click)="toPicker.open()" readonly
                            placeholder="To date" [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}">
                        <mat-datepicker-toggle matSuffix [for]="toPicker">
                            <img matDatepickerToggleIcon src="assets/images/bx-calendar.svg">
                        </mat-datepicker-toggle>
                        <mat-datepicker #toPicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-4 ms-auto">
                    <div class="d-flex justify-content-end" style="margin-top: 31px;">
                        <button type="button" class="btn submit-btn-solid" (click)="submitDateFilter()">
                            Submit
                        </button>
                        <button type="button" class="btn btn-btn-grey" (click)="resetDateFilter()">
                            Reset
                        </button>
                    </div>
                </div>
            </form>
            <div class="cab-board"
                *ngIf="isOnCallActionAllowed && (ELEMENT_DATA.length > 0 || (searchData || '').trim() || showFlag)">
                <div class="cab-index">
                    <div class="cab-index-head">
                        <div class="cab-search">
                            <input class="form-control icon s-input b-0" type="text"
                                placeholder="Search by reference no, request no, PRO name or city name" [(ngModel)]="searchData"
                                (input)="searchSubject$.next($event.target.value)">
                        </div>
                    </div>

                    <div class="cab-table" *ngIf="ELEMENT_DATA.length; else noRequests">
                        <div class="cab-table-head">
                            <span>Booking Details</span>
                            <span>Date &amp; reporting time</span>
                            <span>Pick up &rarr; Drop</span>
                            <span>Vehicle &amp; allocation</span>
                            <span>Status</span>
                        </div>
                        <button type="button" class="cab-table-row" *ngFor="let element of ELEMENT_DATA"
                            [class.selected]="isSelectedCard(element)" (click)="selectCard(element)">
                            <div class="ref-cell">
                                <div class="meta-line">
                                    <span class="detail-label">Ref No:</span>
                                    <span [ngClass]="element.referenceNo ? 'detail-value' : 'detail-muted'">{{
                                        element.referenceNo || '-' }}</span>
                                </div>
                                <div class="meta-line">
                                    <span class="detail-label">PRO:</span>
                                    <span [ngClass]="element.proDisplayName ? 'detail-value' : 'detail-muted'">{{
                                        element.proDisplayName || '-' }}</span>
                                </div>
                                <div class="meta-line">
                                    <span class="detail-label">Req No:</span>
                                    <span [ngClass]="element.requestNo ? 'detail-value' : 'detail-muted'">{{
                                        element.requestNo || '-' }}</span>
                                </div>
                                <div class="meta-line">
                                    <span class="detail-label">Booked City:</span>
                                    <span
                                        [ngClass]="element.bookedCity && element.bookedCity !== '-' ? 'detail-value' : 'detail-muted'">{{
                                        element.bookedCity || '-' }}</span>
                                </div>
                                <div class="meta-line">
                                    <span class="detail-label">Trip Code:</span>
                                    <span class="trip-code"
                                        [ngClass]="element.tripCode ? 'detail-value' : 'detail-muted'">{{
                                        element.tripCode || '-' }}</span>
                                </div>
                            </div>
                            <div class="when-cell">
                                <strong [ngClass]="element.travelDate ? 'detail-value' : 'detail-muted'">{{
                                    element.travelDate || '-' }}</strong>
                                <small class="time-line detail-muted"
                                    *ngIf="element.travelTime; else noTravelTime"><span class="time-clock"
                                        aria-hidden="true"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor"
                                                stroke-width="1.8" />
                                            <path d="M12 7.5V12l3 2" fill="none" stroke="currentColor"
                                                stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg></span>{{ element.travelTime }}</small>
                                <ng-template #noTravelTime><small class="detail-muted">-</small></ng-template>
                            </div>
                            <div class="route-cell">
                                <div class="route-stop">
                                    <span class="route-dot pickup" aria-hidden="true"></span>
                                    <span class="route-text"
                                        [ngClass]="element.pickUpFrom ? 'detail-value' : 'detail-muted'">{{
                                        element.pickUpFrom || '-' }}</span>
                                </div>
                                <div class="route-stop">
                                    <span class="route-dot drop" aria-hidden="true"></span>
                                    <span class="route-text" [ngClass]="element.dropTo ? 'detail-value' : 'detail-muted'">{{
                                        element.dropTo || '-' }}</span>
                                </div>
                            </div>
                            <div class="alloc-cell">
                                <div class="meta-line">
                                    <span class="detail-label">Vehicle Type:</span>
                                    <span [ngClass]="element.vehicleType ? 'detail-value' : 'detail-muted'">{{
                                        element.vehicleType || '-' }}</span>
                                </div>
                                <div class="meta-line">
                                    <span class="detail-label">Vendor:</span>
                                    <span [ngClass]="element.vendor ? 'detail-value' : 'detail-muted'">{{ element.vendor
                                        || '-' }}</span>
                                </div>
                                <div class="meta-line">
                                    <span class="detail-label">Vehicle no:</span>
                                    <span [ngClass]="element.vehicleNumber ? 'detail-value' : 'detail-muted'">{{
                                        element.vehicleNumber || '-' }}</span>
                                </div>
                                <div class="meta-line">
                                    <span class="detail-label">Driver:</span>
                                    <span [ngClass]="element.driver ? 'detail-value' : 'detail-muted'">{{ element.driver
                                        || '-' }}</span>
                                </div>
                            </div>
                            <div class="status-cell">
                                <span class="status-col">
                                    <span class="running-live" *ngIf="isTripRunning(element)"><span class="live-dot"></span>Running</span>
                                    <span class="status-pill" [ngClass]="statusTone(element)">
                                        <i></i>{{ cardStatusLabel(element) }}
                                    </span>
                                </span>
                                <em class="bx bx-chevron-right"></em>
                            </div>
                        </button>
                    </div>
                    <ng-template #noRequests>
                        <div class="row mt-5">
                            <div class="col-sm-12 col-md-12">
                                <h4
                                    class="tdw-text-align-center tdw-font-normal tdw-margin-4 mat-color-text--blue-grey-600">
                                    --No Data Found --</h4>
                            </div>
                        </div>
                    </ng-template>
                    <div class="cab-list-footer" *ngIf="ELEMENT_DATA.length">
                        <span class="showing-text">Showing {{ ELEMENT_DATA.length }} booking{{ ELEMENT_DATA.length === 1
                            ? '' : 's' }}</span>
                    </div>
                </div>

                <div class="cab-drawer-backdrop" *ngIf="selectedCard as booking" (click)="clearSelection()"></div>
                <aside class="cab-drawer" *ngIf="selectedCard as booking">
                    <header class="cab-drawer-head">
                        <div class="detail-title">
                            <h3><span class="detail-label">Ref No:</span> <span class="ref-no-value">{{
                                    booking.referenceNo || '-' }}</span></h3>
                            <small *ngIf="booking.isVendorApproved === true"><span class="detail-label">Approved
                                    by:</span> <span class="detail-value">Vendor</span></small>
                            <small *ngIf="booking.isVendorApproved === false"><span class="detail-label">Approved
                                    by:</span> <span class="detail-value">PRO</span></small>
                            <small *ngIf="booking.isVendorApproved == null"><span class="detail-label">Approved
                                    by:</span> <span class="detail-value">Not yet approved</span></small>
                            <small>
                                <span class="detail-label">Requested by:</span>
                                <span [ngClass]="booking.requestorName ? 'detail-value' : 'detail-muted'">{{
                                    booking.requestorName || '-' }}</span>
                                <ng-container *ngIf="booking.bookedDate"> <span class="detail-value">on {{
                                        booking.bookedDate }}</span></ng-container>
                            </small>
                        </div>
                        <div class="detail-title-side">
                            <span class="status-pill" [ngClass]="statusTone(booking)">
                                <i></i>{{ cardStatusLabel(booking) }}
                            </span>
                            <button type="button" class="cab-drawer-download" title="Download PDF"
                                aria-label="Download PDF" *ngIf="cardStatusLabel(booking) === 'Trip Completed'"
                                (click)="downloadDutySlip(booking)">
                                <img src="./assets/images/pdf.svg" alt="">
                            </button>
                            <button type="button" class="cab-drawer-close" (click)="clearSelection()"
                                aria-label="Close">&times;</button>
                        </div>
                    </header>

                    <div class="cab-drawer-body">
                        <div class="detail-pair">
                            <div class="drawer-card">
                                <div class="cab-section-title">Trip</div>
                                <div class="trip-line">
                                    <span class="trip-pin" aria-hidden="true">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1E9E5A"
                                            stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M12 22s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12z"></path>
                                            <circle cx="12" cy="10" r="2.5"></circle>
                                        </svg>
                                    </span>
                                    <span class="trip-stop">
                                        <span class="detail-label pickup-label">PICKUP</span>
                                        <span [ngClass]="booking.pickUpFrom ? 'detail-value' : 'detail-muted'">{{
                                            booking.pickUpFrom || '-' }}</span>
                                    </span>
                                </div>
                                <div class="trip-line end">
                                    <span class="trip-pin drop" aria-hidden="true">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF"
                                            stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M12 22s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12z"></path>
                                            <circle cx="12" cy="10" r="2.5"></circle>
                                        </svg>
                                    </span>
                                    <span class="trip-stop">
                                        <span class="detail-label">DROP</span>
                                        <span [ngClass]="booking.dropTo ? 'detail-value' : 'detail-muted'">{{
                                            booking.dropTo || '-' }}</span>
                                    </span>
                                </div>
                                <div class="pair-meta">
                                    <div>
                                        <label class="detail-label">Reporting Time</label>
                                        <strong [ngClass]="booking.travelDate ? 'detail-value' : 'detail-muted'">{{
                                            booking.travelDate || '-' }}<ng-container *ngIf="booking.travelTime">, {{
                                                booking.travelTime
                                                }}</ng-container></strong>
                                    </div>
                                    <div>
                                        <label class="detail-label">Escort</label>
                                        <strong [ngClass]="booking.escort ? 'detail-value' : 'detail-muted'">{{
                                            booking.escort || '-' }}</strong>
                                    </div>
                                    <div>
                                        <label class="detail-label">PRO Location &amp; Site</label>
                                        <strong
                                            [ngClass]="proLocationSite(booking) !== '-' ? 'detail-value' : 'detail-muted'">{{
                                            proLocationSite(booking) }}</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="drawer-card">
                                <div class="cab-section-title">Vehicle &amp; Allocation</div>
                                <div class="alloc-grid">
                                    <div>
                                        <label class="detail-label">Vehicle Type</label>
                                        <strong
                                            [ngClass]="isUnassigned(booking.vehicleType) ? 'detail-muted' : 'detail-value'">{{
                                            booking.vehicleType || '-' }}</strong>
                                    </div>
                                    <div>
                                        <label class="detail-label">Vehicle No.</label>
                                        <strong
                                            [ngClass]="isUnassigned(booking.vehicleNumber) ? 'detail-muted' : 'detail-value'">{{
                                            booking.vehicleNumber || '-' }}</strong>
                                    </div>
                                    <div>
                                        <label class="detail-label">Driver</label>
                                        <strong
                                            [ngClass]="isUnassigned(booking.driver) ? 'detail-muted' : 'detail-value'">{{
                                            booking.driver || '-'
                                            }}</strong>
                                    </div>
                                    <div>
                                        <label class="detail-label">Driver No.</label>
                                        <strong
                                            [ngClass]="isUnassigned(booking.driverNumber) ? 'detail-muted' : 'detail-value'">{{
                                            isUnassigned(booking.driverNumber) ? '–' : booking.driverNumber }}</strong>
                                    </div>
                                    <div class="vendor-full">
                                        <label class="detail-label">Vendor</label>
                                        <strong
                                            [ngClass]="isUnassigned(booking.vendor) ? 'detail-muted' : 'detail-value'">{{
                                            booking.vendor || '-'
                                            }}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="cab-section-title section-gap">Booking &amp; Billing</div>
                        <div class="billing-section">
                            <div class="billing-grid">
                                <div>
                                    <label class="detail-label">Booked City</label>
                                    <span class="billing-value"
                                        [ngClass]="booking.bookedCity && booking.bookedCity !== '-' ? 'detail-value' : 'detail-muted'">{{
                                        booking.bookedCity || '-' }}</span>
                                </div>
                                <div>
                                    <label class="detail-label">Booking Type</label>
                                    <span class="billing-value"
                                        [ngClass]="booking.bookingType ? 'detail-value' : 'detail-muted'">{{
                                        booking.bookingType || '-' }}</span>
                                </div>
                                <div>
                                    <label class="detail-label">Cost Center</label>
                                    <span class="billing-value"
                                        [ngClass]="booking.costCenter ? 'detail-value' : 'detail-muted'">{{
                                        booking.costCenter || '-' }}</span>
                                </div>
                                <div>
                                    <label class="detail-label">Billing Entity</label>
                                    <span class="billing-value"
                                        [ngClass]="booking.billingEntity ? 'detail-value' : 'detail-muted'">{{
                                        booking.billingEntity || '-' }}</span>
                                </div>
                                <div>
                                    <label class="detail-label">Billing Responsibility</label>
                                    <span class="billing-value"
                                        [ngClass]="booking.billingResponsibility ? 'detail-value' : 'detail-muted'">{{
                                        booking.billingResponsibility || '-' }}</span>
                                </div>
                                <div>
                                    <label class="detail-label">Duration</label>
                                    <span class="billing-value"
                                        [ngClass]="booking.duration ? 'detail-value' : 'detail-muted'">{{
                                        booking.duration || '-' }}</span>
                                </div>
                                <div>
                                    <label class="detail-label">Company Name</label>
                                    <span class="billing-value"
                                        [ngClass]="booking.gstCorporateName ? 'detail-value' : 'detail-muted'">{{
                                        booking.gstCorporateName || '-' }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="cab-section-title section-gap">Passengers ({{ (booking.passengers || []).length }})
                        </div>
                        <div class="passenger-row" *ngFor="let emp of (booking.passengers || []); let i = index">
                            <span class="avatar" [class.alt]="i % 2 === 1">{{ passengerInitial(emp.name) }}</span>
                            <div class="passenger-id">
                                <strong [ngClass]="emp.name ? 'detail-value' : 'detail-muted'">{{ emp.name || '-'
                                    }}<ng-container *ngIf="emp.employeeId && emp.employeeId !== '-'"> (Emp ID: {{
                                        emp.employeeId
                                        }})</ng-container></strong>
                                <small class="detail-muted">{{ emp.email || '-' }}</small>
                            </div>
                            <span class="passenger-phone"
                                [ngClass]="emp.contactNumber ? 'detail-value' : 'detail-muted'">{{ emp.contactNumber ||
                                '-' }}</span>
                            <div class="passenger-otp">
                                <label class="detail-label">OTP</label>
                                <strong [ngClass]="emp.password ? 'detail-value' : 'detail-muted'">{{ emp.password ||
                                    '-' }}</strong>
                            </div>
                        </div>

                        <div class="cab-section-title section-gap">Status &amp; Reasons</div>
                        <div class="status-box">
                            <div class="status-line"><label class="detail-label">Trip Status</label><strong
                                    [ngClass]="booking.deviceTripStatus && booking.deviceTripStatus !== 'NA' ? 'detail-value' : 'detail-muted'">{{
                                    booking.deviceTripStatus &&
                                    booking.deviceTripStatus !== 'NA' ? booking.deviceTripStatus : 'not started'
                                    }}</strong></div>
                            <div class="status-line"><label class="detail-label">Instruction</label><strong
                                    [ngClass]="booking.reason ? 'detail-value' : 'detail-muted'">{{ booking.reason ||
                                    'NA'
                                    }}</strong></div>
                            <div class="status-line"><label class="detail-label">Divert Reason/Remarks</label><strong
                                    [ngClass]="booking.divertReason ? 'detail-value' : 'detail-muted'">{{
                                    booking.divertReason || 'NA'
                                    }}</strong></div>
                            <div class="status-line"><label class="detail-label">Vendor Reject
                                    Reason/Remarks</label><strong
                                    [ngClass]="booking.vendorRejectReason ? 'detail-value' : 'detail-muted'">{{
                                    booking.vendorRejectReason || 'NA' }}</strong></div>
                        </div>
                    </div>

                    <div class="cab-drawer-footer"
                        *ngIf="hasAction(booking) || isTripRunning(booking) || booking.deviceTripStatus == 'stopped' || booking.deviceTripStatus == 'STOPPED'">
                        <button type="button" class="cab-btn restart"
                            *ngIf="booking.deviceTripStatus == 'stopped' || booking.deviceTripStatus == 'STOPPED'"
                            (click)="restartTrip(booking)">Restart</button>
                        <button type="button" class="cab-btn reset" *ngIf="canResetRunningTrip(booking)"
                            (click)="resetRunningTrip(booking)">Reset</button>
                        <ng-container
                            *ngIf="booking.status=='SENT_FOR_VENDOR_APPROVAL' && !isNewFlowActionBlocked(booking)">
                            <button type="button" class="cab-btn approve" (click)="acceptTrip(booking)">Accept</button>
                            <button type="button" class="cab-btn reject"
                                (click)="rejectOnCallBooking(booking)">Reject</button>
                        </ng-container>
                        <ng-container *ngIf="booking.status=='ACCEPTED_BY_VENDOR' && !isNewFlowActionBlocked(booking)">
                            <button type="button" class="cab-btn approve"
                                (click)="openApproveDialog(booking)">Approve</button>
                            <button type="button" class="cab-btn reject"
                                (click)="rejectOnCallBooking(booking)">Reject</button>
                        </ng-container>
                        <ng-container *ngIf="isApprovedStatus(booking) && !isNewFlowActionBlocked(booking)">
                            <button type="button" class="cab-btn edit"
                                (click)="openApproveDialog(booking, true)">Edit</button>
                        </ng-container>
                        <button type="button" class="cab-btn stop" *ngIf="isTripRunning(booking)"
                            (click)="stopTrip(booking)">Stop</button>
                    </div>
                </aside>
            </div>
        </div>
    </div>
</div>